module.exports = __webpack_public_path__ + "static/media/206-Telefonat_ID_35.c32c278a.mp3";